import Vue from 'vue';
import App from './App.vue';
import EventApp from './EventApp.vue';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

declare var markersUrl: string;
declare var listUrl: string;
declare var searchUrl: string;
declare var categories: {uid: number, name: string}[];
declare var apiKey: string;
declare var selectedCategories: number[];

Vue.config.productionTip = false;
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

if (document.getElementById('dalzg-addresses-app')) {
  new Vue({
    render: (h) => h(App, {
      props: {
        markersUrl: markersUrl,
        listUrl: listUrl,
        searchUrl: searchUrl,
        categories: categories,
        apiKey: apiKey,
      },
    }),
  }).$mount('#dalzg-addresses-app');
}

if (document.getElementById('dalzg-events-app')) {
  new Vue({
    render: (h) => h(EventApp, {
      props: {
        markersUrl: markersUrl,
        listUrl: listUrl,
        searchUrl: searchUrl,
        categories: categories,
        apiKey: apiKey,
        selectedCategories: selectedCategories,
      },
    }),
  }).$mount('#dalzg-events-app');
}

